export const objGetProp = (obj, propPath) =>
  propPath.split('.').reduce((obj, prop) => (obj && obj[prop] ? obj[prop] : undefined), obj);
export const isDefined = (value) => value !== undefined && value !== null;
